import { NguCarouselConfig } from '@ngu/carousel';
import { STORAGE_KEYS_CONSTANTS } from './storage-keys';
import { INavigation } from '@core/models';
import { getSessionStorage, setSessionStorage } from '@shared/utils';

export const APP_CONSTANTS = {
  /** URL of the form for provider registration */
  // URL_FORM_PROVIDER: 'https://arcg.is/TLDrr0',

  /** llave o clave constante para la cabecera de la petición */
  NAME_TOKEN_HEADER: 'Bearer',

  /** llave o clave constante  que define la maxima calificación ya sea para un geomarcador o un municipio */
  MAX_RATING: 5,

  /**llave o clave constante que determina cuantos elementos habra por página, es utilizado en la seccion general de municipios */
  PAGINATION_ITEMS_PER_PAGE: 10,

  /** Objeto constante que define la ubicacion por defecto en el mapa de busqueda */
  DEFAULT_LONG_LAT: {
    lng: -75.0923168,
    lat: 4.7815835,
  },

  DEFAULT_LIMIT: 20,

  /**
   * Objeto constante que define las diferentes maneras de organizar la información
   */
  CITIES_ORDERS: {
    GOLDEN: 'golden',
    MORE_VALUATIONS: 'reviews',
    BEST_QUALIFICATIONS: 'rated',
    ALPHABETICALLY: '',
  },

  /**
   * Arreglo de objetos que contiene y define los meses del año, aqui encontrara la abreviacion, su nombre y la clave translate que es la que se usara la hora de renderizar
   * el contenido en la página.
   */
  MONTHS: [
    {
      abbreviation: 'Jan',
      name: 'January',
      translate: 'january',
    },
    {
      abbreviation: 'Feb',
      name: 'February',
      translate: 'january',
    },
    {
      abbreviation: 'Mar',
      name: 'March',
      translate: 'january',
    },
    {
      abbreviation: 'Apr',
      name: 'April',
      translate: 'january',
    },
    {
      abbreviation: 'May',
      name: 'May',
      translate: 'january',
    },
    {
      abbreviation: 'Jun',
      name: 'June',
      translate: 'january',
    },
    {
      abbreviation: 'Jul',
      name: 'July',
      translate: 'january',
    },
    {
      abbreviation: 'Aug',
      name: 'August',
      translate: 'january',
    },
    {
      abbreviation: 'Sep',
      name: 'September',
      translate: 'january',
    },
    {
      abbreviation: 'Oct',
      name: 'October',
      translate: 'january',
    },
    {
      abbreviation: 'Nov',
      name: 'November',
      translate: 'january',
    },
    {
      abbreviation: 'Dec',
      name: 'December',
      translate: 'january',
    },
  ],

  /**
   * Object that contains the bootstrap breakpoints in numeric format, these are used in the application to define the size of the elements on the screen
   */
  BREAKPOINTS_BOOTSTRAP_NUMBER: {
    XS: 576,
    SM: 768,
    MD: 992,
    LG: 1200,
    XL: 1400,
  } as const,

  /**
   * Objeto que contiene los breakpoints de bootstrap, estos son utilizados en la aplicación para definir el tamaño de los elementos en la pantalla
   */
  BREAKPOINTS_BOOTSTRAP: {
    XS: '(max-width: 575px)',
    SM: '(min-width: 576px) and (max-width: 767.98px)',
    MD: '(min-width: 768px) and (max-width: 991.98px)',
    LG: '(min-width: 992px) and (max-width: 1199.98px)',
    XL: '(min-width: 1200px) and (max-width: 1399.98px)',
    XXL: '(min-width: 1400px)',
  } as const,

  /**
   *  Variable de tipo **NguCarouselConfig**, este es un arreglo de objetos que contendran la configuración para los sliders o ventanas deslizantes que se utilizarán en la aplicación,
   *  para mas información consultar la documentacion oficial [ngu-carousel](https://www.npmjs.com/package/@ngu/carousel).
   */
  CAROUSEL_DEFAULT_CONFIG: {
    grid: { xs: 1, sm: 2, md: 3, lg: 4, all: 0 },
    speed: 250,
    point: {
      visible: true,
    },
    slide: 1,
    touch: true,
    loop: true,
    interval: { timing: 8500 },
  } as NguCarouselConfig,

  /**
   * Array de objetos de tipo INavigation, al ser de tipo export permite al usuario importarla o usarla en los distintos componentes de la aplicación,
   * contiene dos claves **routing_path** que funcionará como palabra reservada la cual nos redirigirá a la sección que le específique y **translate**
   * que será el nombre renderizado en el menú de navegación de la app.
   */
  NAVIGATION: [
    {
      routing_path: 'home',
      translate: 'navigation.init',
    },
    {
      routing_path: 'search',
      translate: 'navigation.places_and_providers',
    },
    {
      routing_path: 'cities',
      translate: 'navigation.cities',
    },
    {
      routing_path: 'weathers',
      translate: 'navigation.climates',
    },
    {
      routing_path: 'routes',
      translate: 'navigation.tourism_trace',
    },

    {
      routing_path: 'contact',
      translate: 'navigation.contact',
    },
    // {
    //   routing_path: 'register-company',
    //   translate: 'navigation.register_business',
    // },
  ] as INavigation[],
} as const;

export class CuriosityUtil {
  /**
   * Método estatico que sirve para saber si es que el usuario tiene permiso de mostrar las curiosidades o no
   */
  static showCuriosity(): boolean {
    const existCuriosity = !!getSessionStorage(STORAGE_KEYS_CONSTANTS.CURIOSITY_TOKEN);
    if (!existCuriosity) {
      return false;
    } else {
      const curiosityToken = getSessionStorage(STORAGE_KEYS_CONSTANTS.CURIOSITY_TOKEN);
      return curiosityToken || false;
    }
  }

  /**
   * Metodo que envia a almacenamiento de sesion el valor que le llega por parametro respecto
   * a la visibilidad de la curiosidad, esta es usada en el **componente**  {@link ProfileCuriositiesComponent}
   * @param value Parametro de tipo any que sera enviado al almcenamiento de sesion
   */
  static setCuriosity(value: any): void {
    return setSessionStorage(STORAGE_KEYS_CONSTANTS.CURIOSITY_TOKEN, JSON.stringify(value));
  }
}
